<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path v-if="!minus" fill-rule="evenodd" clip-rule="evenodd" d="M12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5V11.25H19.5C19.9142 11.25 20.25 11.5858 20.25 12C20.25 12.4142 19.9142 12.75 19.5 12.75H12.75V19.5C12.75 19.9142 12.4142 20.25 12 20.25C11.5858 20.25 11.25 19.9142 11.25 19.5V12.75H4.5C4.08579 12.75 3.75 12.4142 3.75 12C3.75 11.5858 4.08579 11.25 4.5 11.25H11.25V4.5C11.25 4.08579 11.5858 3.75 12 3.75Z" fill="#283380" />
        <path v-else fill-rule="evenodd" clip-rule="evenodd" d="M4.7998 12.0016C4.7998 11.5045 5.20275 11.1016 5.6998 11.1016L18.2998 11.1016C18.7969 11.1016 19.1998 11.5045 19.1998 12.0016C19.1998 12.4986 18.7969 12.9016 18.2998 12.9016L5.6998 12.9016C5.20275 12.9016 4.7998 12.4986 4.7998 12.0016Z" />
    </svg>
</template>

<script lang="ts" setup>
defineProps<{ minus?: boolean }>()
</script>

<style lang="scss" scoped>
svg {
    path {
        fill: var(--color-primary);
    }
}
</style>